import { LOCAL_STORAGE_KEYS } from "../../common/constants";
import {
  BreadCrumbItemType,
  SelectOptionInterface,
  SelectVerticalOptionInterface,
} from "../../common/types";
import { getInitialVerticals } from "../../common/utils";
import { COMMON_ACTIONS } from "../thunks/common.thunk";

interface CommonSliceProps {
  breadCrumb: BreadCrumbItemType[];
  history: string[];
  verticals: {
    [key: string]: SelectVerticalOptionInterface;
  };
  contractTypes: {
    [key: string]: SelectOptionInterface;
  };
}

const initialState: CommonSliceProps = {
  breadCrumb: [],
  history: [],
  verticals: getInitialVerticals(),
  contractTypes: {},
};

export default function commonReducer(state = initialState, action: any) {
  switch (action.type) {
    case COMMON_ACTIONS.ADD_BREADCRUMB:
      var breadCrumbCopy = state.breadCrumb.slice();
      if (Array.isArray(action.payload)) {
        action.payload.forEach((item: BreadCrumbItemType) => {
          breadCrumbCopy.push(item);
        });
      }
      state = {
        ...state,
        breadCrumb: breadCrumbCopy,
      };
      return state;

    case COMMON_ACTIONS.REMOVE_BREADCRUMB:
      breadCrumbCopy = state.breadCrumb.slice();

      if (Array.isArray(action.payload)) {
        action.payload.forEach((item: BreadCrumbItemType) => {
          var index = breadCrumbCopy.findIndex(
            (breadCrumb: BreadCrumbItemType) => breadCrumb.text === item.text
          );

          if (index > -1) {
            breadCrumbCopy.splice(index, 1);
          }
        });
      }
      state = {
        ...state,
        breadCrumb: breadCrumbCopy,
      };
      return state;

    case COMMON_ACTIONS.SET_HISTORY:
      let temp: any = state.history;
      const index = temp.indexOf(action.payload);
      if (index === -1) {
        temp.push(action.payload);
      } else {
        temp.splice(index + 1);
      }

      state = {
        ...state,
        history: temp,
      };

      return state;

    case COMMON_ACTIONS.RESET_HISTORY:
      state = {
        ...state,
        history: [],
      };

      return state;

    case COMMON_ACTIONS.SET_VERTICAL:
      // Check if the new vertical data is different from current state
      const currentVertical = state.verticals[action?.payload?.feature];
      const newVertical = action?.payload?.data || { label: "", value: "" };

      // If data is the same, return current state without updates
      if (
        currentVertical?.label === newVertical?.label &&
        currentVertical?.value === newVertical?.value
      ) {
        return state;
      }

      // Only update if vertical data has changed
      state = {
        ...state,
        verticals: {
          ...state.verticals,
          [action?.payload?.feature]: newVertical,
        },
      };

      // Update localStorage only if data changed
      const verticalDataInLS = localStorage.getItem(
        LOCAL_STORAGE_KEYS.VERTICALS
      );
      localStorage.setItem(
        LOCAL_STORAGE_KEYS.VERTICALS,
        JSON.stringify({
          ...JSON.parse(verticalDataInLS || "{}"),
          [action?.payload?.feature]: newVertical,
        })
      );
      return state;

    case COMMON_ACTIONS.RESET_VERTICAL:
      state = {
        ...state,
        verticals: {
          ...state.verticals,
          [action?.payload?.feature]: {
            label: "",
            value: "",
          },
        },
      };
      return state;

    case COMMON_ACTIONS.SET_CONTRACT_TYPE:
      state = {
        ...state,
        contractTypes: {
          ...state.contractTypes,
          [action?.payload?.feature]:
            action?.payload?.data || { label: "", value: "" },
        },
      };
      return state;

    case COMMON_ACTIONS.RESET_CONTRACT_TYPE:
      state = {
        ...state,
        contractTypes: {
          ...state.contractTypes,
          [action?.payload?.feature]: {
            label: "",
            value: "",
          },
        },
      };
      return state;

    default:
      return state;
  }
}
